import type { Translate } from 'next-translate';

export const beginning_q1 = (t: Translate) =>
    [
        { label: t('settings:platform_page.beginning_q1_january'), value: 'january' },
        { label: t('settings:platform_page.beginning_q1_february'), value: 'february' },
        { label: t('settings:platform_page.beginning_q1_march'), value: 'march' },
        { label: t('settings:platform_page.beginning_q1_april'), value: 'april' },
        { label: t('settings:platform_page.beginning_q1_may'), value: 'may' },
        { label: t('settings:platform_page.beginning_q1_june'), value: 'june' },
        { label: t('settings:platform_page.beginning_q1_july'), value: 'july' },
        { label: t('settings:platform_page.beginning_q1_august'), value: 'august' },
        { label: t('settings:platform_page.beginning_q1_september'), value: 'september' },
        { label: t('settings:platform_page.beginning_q1_october'), value: 'october' },
        { label: t('settings:platform_page.beginning_q1_november'), value: 'november' },
        { label: t('settings:platform_page.beginning_q1_december'), value: 'december' }
    ] as const;

export const date_format = (t: Translate) =>
    [
        { label: t('settings:platform_page.date_format_day_month_year'), value: 'day_month_year' },
        { label: t('settings:platform_page.date_format_month_day_year'), value: 'month_day_year' },
        { label: t('settings:platform_page.date_format_year_month_day'), value: 'year_month_day' }
    ] as const;

export const display_insights_banner = (t: Translate) =>
    [
        {
            label: t('settings:platform_page.display_insights_banner_yes'),
            value: true
        },
        {
            label: t('settings:platform_page.display_insights_banner_no'),
            value: false
        }
    ] as const;

export const enable_notifications = (t: Translate) =>
    [
        {
            label: t('commons:yes'),
            value: true
        },
        {
            label: t('commons:no'),
            value: false
        }
    ] as const;

export const export_csv_delimiter = (t: Translate) =>
    [
        { label: t('settings:platform_page.export_csv_delimiter_,'), value: ',' },
        { label: t('settings:platform_page.export_csv_delimiter_;'), value: ';' }
    ] as const;

export const first_day_week = (t: Translate) =>
    [
        { label: t('settings:platform_page.first_day_week_monday'), value: 'monday' },
        { label: t('settings:platform_page.first_day_week_sunday'), value: 'sunday' }
    ] as const;

export const homepage = (t: Translate) =>
    [
        { label: t('settings:platform_page.homepage_welcome_page'), value: 'welcome_page' },
        { label: t('settings:platform_page.homepage_analyze_overview'), value: 'analyze_overview' },
        { label: t('settings:platform_page.homepage_content_posts'), value: 'content_posts' },
        {
            label: t('settings:platform_page.homepage_publishing_scheduler'),
            value: 'publishing_scheduler'
        },
        { label: t('settings:platform_page.homepage_conversations'), value: 'conversations' },
        {
            label: t('settings:platform_page.homepage_listening_competitors'),
            value: 'listening_competitors'
        }
    ] as const;

export const numbers_format = (t: Translate) =>
    [
        { label: t('settings:platform_page.numbers_format_space'), value: 'space' },
        { label: t('settings:platform_page.numbers_format_comma'), value: 'comma' },
        { label: t('settings:platform_page.numbers_format_dot'), value: 'dot' }
    ] as const;

export const platform_language = (t: Translate) =>
    [
        { label: t('commons:platform_languages.platform_language_en'), value: 'en' },
        { label: t('commons:platform_languages.platform_language_fr'), value: 'fr' },
        { label: t('commons:platform_languages.platform_language_es'), value: 'es' }
    ] as const;

export const posts_per_line = (t: Translate) =>
    [
        { label: t('settings:platform_page.posts_per_line_3'), value: '3' },
        { label: t('settings:platform_page.posts_per_line_4'), value: '4' },
        { label: t('settings:platform_page.posts_per_line_5'), value: '5' }
    ] as const;

export const registered_from = (t: Translate) =>
    [
        { label: t('settings:platform_page.registered_from_web'), value: 'web' },
        { label: t('settings:platform_page.registered_from_ios'), value: 'ios' },
        { label: t('settings:platform_page.registered_from_android'), value: 'android' }
    ] as const;

export const time_format = (t: Translate) =>
    [
        { label: t('settings:platform_page.time_format_12'), value: '12' },
        { label: t('settings:platform_page.time_format_24'), value: '24' }
    ] as const;

export const validate_auto_publishing_mobile_app = (t: Translate) =>
    [
        {
            label: t('settings:platform_page.validate_auto_publishing_mobile_app_yes'),
            value: true
        },
        {
            label: t('settings:platform_page.validate_auto_publishing_mobile_app_no'),
            value: false
        }
    ] as const;

export const enable_weekly_digest_email = (t: Translate) =>
    [
        {
            label: t('settings:platform_page.enable_weekly_digest_email_yes'),
            value: true
        },
        {
            label: t('settings:platform_page.enable_weekly_digest_email_no'),
            value: false
        }
    ] as const;

export const enable_monthly_digest_email = (t: Translate) =>
    [
        {
            label: t('commons:yes'),
            value: true
        },
        {
            label: t('commons:no'),
            value: false
        }
    ] as const;
